import { I18nComponente } from "@/types/gerais"

export const OTipoAtividadeIdi18n: I18nComponente = {
  "pt-BR": {
    nome: "nome",
    codigo: "codigo",
    duracao: "duração:",
    campoObrigatorio: "campos obrigatório",
  },
  "es-CO": {
    nome: "nombre",
    codigo: "codigo",
    duracao: "duración:",
    campoObrigatorio: "campos obligatorio",
  }
}
